import React, { useState, useEffect } from "react";
import "./Layouts.css";
import { FaShoppingCart } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import { Modal, Button } from "react-bootstrap";
import Axios from "../../../axios/axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";

const TopSearchBar = () => {
  const navigate = useNavigate();
  const [userInfo, setUserInfo] = useState(null);
  const [productType, setProductType] = useState(
    sessionStorage.getItem("businessType") || ""
  );
  const [searchKeyword, setSearchKeyword] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [allProducts, setAllProducts] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [error, setError] = useState("");
  const [cartTotal, setCartTotal] = useState(0);
  const [excelModalOpen, setExcelModalOpen] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploadLoading, setUploadLoading] = useState(false);
  const [uploadResponse, setUploadResponse] = useState(null);
  const [uploadError, setUploadError] = useState(null);
  const [customerBalance, setCustomerBalance] = useState(null);

  const referenceExcelLink =
    productType === "Rental"
      ? "/excel/RentalOrderCreateExcelFormat.xlsx"
      : "/excel/OrderCreateExcelFormat.xlsx";

  useEffect(() => {
    const fetchCartTotal = async () => {
      const userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
      const customerId = userInfo?.customerId;

      if (!customerId) return;

      try {
        const res = await Axios.get(`/cart/${customerId}`);
        const businessType = sessionStorage.getItem("businessType");

        const filteredItems =
          res.data?.items?.filter((item) =>
            item.productType.includes(businessType)
          ) || [];
        const total = filteredItems.reduce(
          (sum, item) => sum + item.totalItemPrice,
          0
        );
        setCartTotal(total);
      } catch (error) {
        console.error("Error fetching cart total in header:", error);
      }
    };

    fetchCartTotal();
  }, []);

  useEffect(() => {
    LoginData();
  }, []);

  useEffect(() => {
    const storedProductType = sessionStorage.getItem("businessType");
    if (storedProductType) {
      setProductType(storedProductType);
    }
  }, []);

  useEffect(() => {
    const fetchCustomerBalance = async () => {
      const userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
      const customerId = userInfo?.customerId;
      if (!customerId) return;

      try {
        const res = await Axios.get(`/customer/get/${customerId}`);
        setCustomerBalance(parseFloat(res.data?.balance || 0));
      } catch (error) {
        console.error("Error fetching customer balance:", error);
      }
    };

    fetchCustomerBalance();
  }, []);

  const handleSearch = async (e) => {
    e.preventDefault();
    setError("");
    setSearchResults([]);

    if (!productType || !searchKeyword.trim()) {
      setError("Both product type and search keyword are required.");
      setShowModal(true);
      return;
    }

    try {
      const response = await Axios.post("/searchfilter", {
        type: productType,
        productName: searchKeyword,
      });

      setSearchResults(response.data);
      setShowModal(true);
    } catch (err) {
      setError(err.response?.data?.message || err.message);
      setShowModal(true);
    }
  };

  const LoginData = () => {
    const userInfoString = sessionStorage.getItem("userInfo");
    if (userInfoString) {
      const parsed = JSON.parse(userInfoString);
      setUserInfo(parsed);
    } else {
      console.log("No user info found in session storage.");
    }
  };

  const handleProductClick = (product) => {
    setShowModal(false);

    if (product.productType?.includes("Engineering")) {
      navigate(`/engineering/product/single/${product._id}`);
    } else if (product.productType?.includes("Auto-Spare")) {
      navigate(`/singleproduct/${product._id}`);
    } else if (product.productType?.includes("Building")) {
      navigate(`/others/product/single/${product._id}`);
    } else {
      navigate(`/rental/product/single/${product._id}`);
    }
  };

  const handleExcelUpload = async () => {
    if (!selectedFile) return;

    setUploadLoading(true);
    setUploadError(null);
    setUploadResponse(null);

    const formData = new FormData();
    formData.append("file", selectedFile);

    const userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    formData.append("customerName", userInfo.username);
    formData.append("customerId", userInfo.customerId);
    formData.append("businessType", sessionStorage.getItem("businessType"));

    try {
      const response = await Axios.post("/upload-excel", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      setUploadResponse(response.data.results);
      setExcelModalOpen(false);
      setSelectedFile(null);
      toast.success("Your order has been placed successfully!");
      console.log("Upload Success:", response.data);
    } catch (err) {
      console.error("Upload Error:", err);
      setUploadError("Upload failed. Please try again.");
    } finally {
      setUploadLoading(false);
    }
  };

  return (
    <>
      <div className="top-search-wrapper">
        <div
          className={`top-search-container ${
            userInfo ? "logged-in" : "logged-out"
          }`}
        >
          {/* Logo */}
          <div className="tsb-logo">
            <Link to="/">
              <img src={"/images/logo.svg"} alt="Logo" />
            </Link>
          </div>

          {/* Search Input */}
          <div className="tsb-search-box">
            <form
              onSubmit={handleSearch}
              style={{ display: "flex", width: "100%" }}
            >
              <input
                type="text"
                placeholder="Search keyword here"
                value={searchKeyword}
                onChange={(e) => setSearchKeyword(e.target.value)}
              />
              <button type="submit" className="tsb-search-btn">
                Search
              </button>
            </form>
          </div>

          {userInfo && (
            <>
              <div
                className="tsb-upload"
                onClick={() => setExcelModalOpen(true)}
                style={{ cursor: "pointer" }}
              >
                Upload excel quotation
              </div>

              <div className="tsb-cart">
                <FaShoppingCart className="tsb-cart-icon" />
                <span
                  className={`tsb-cart-price ${
                    customerBalance < 0 ? "text-success" : "text-danger"
                  }`}
                >
                  {customerBalance !== null
                    ? Math.abs(customerBalance).toFixed(2)
                    : "0.00"}
                </span>
              </div>
            </>
          )}
        </div>
      </div>

      {/* Search Results Modal */}
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Search Results</Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{
            padding: "20px",
            maxHeight: "500px",
            overflowY: "auto",
            backgroundColor: "#f8f9fa",
          }}
        >
          {error ? (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                padding: "40px 20px",
              }}
            >
              <img
                src="/images/no-data.avif"
                alt="No data"
                style={{
                  width: "250px",
                  maxWidth: "100%",
                  marginBottom: "20px",
                  opacity: 0.8,
                }}
              />
              <p
                style={{
                  color: "#6c757d",
                  fontSize: "16px",
                  fontWeight: "500",
                }}
              >
                {error}
              </p>
            </div>
          ) : searchResults.length > 0 ? (
            <div
              style={{ display: "flex", flexDirection: "column", gap: "12px" }}
            >
              {searchResults.map((product) => (
                <div
                  key={product._id}
                  onClick={() => handleProductClick(product)}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "15px",
                    padding: "15px",
                    backgroundColor: "#ffffff",
                    borderRadius: "10px",
                    border: "1px solid #e0e0e0",
                    cursor: "pointer",
                    transition: "all 0.3s ease",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-2px)";
                    e.currentTarget.style.boxShadow =
                      "0 4px 12px rgba(0,0,0,0.1)";
                    e.currentTarget.style.borderColor = "#007bff";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.boxShadow =
                      "0 2px 4px rgba(0,0,0,0.05)";
                    e.currentTarget.style.borderColor = "#e0e0e0";
                  }}
                >
                  {/* Product Image */}
                  <div
                    style={{
                      width: "80px",
                      height: "80px",
                      minWidth: "80px",
                      borderRadius: "8px",
                      overflow: "hidden",
                      backgroundColor: "#f0f0f0",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      border: "1px solid #e0e0e0",
                    }}
                  >
                    <img
                      src={
                        product?.images?.[0]?.url ||
                        "/images/placeholder-product.png"
                      }
                      alt={
                        product.name || product.partName || product.meterialName
                      }
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                      onError={(e) => {
                        e.target.style.display = "none";
                        e.target.parentElement.innerHTML =
                          '<div style="color: #999; font-size: 12px; text-align: center;">No Image</div>';
                      }}
                    />
                  </div>

                  {/* Product Details */}
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <h5
                      style={{
                        margin: "0 0 8px 0",
                        fontSize: "16px",
                        fontWeight: "600",
                        color: "#212529",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {product.name || product.partName || product.meterialName}
                    </h5>

                    <div
                      style={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: "12px",
                        fontSize: "13px",
                        color: "#6c757d",
                      }}
                    >
                      <span
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          gap: "4px",
                        }}
                      >
                        <strong style={{ color: "#495057" }}>Type:</strong>
                        <span
                          style={{
                            padding: "2px 8px",
                            backgroundColor: "#e7f3ff",
                            color: "#0066cc",
                            borderRadius: "4px",
                            fontSize: "12px",
                          }}
                        >
                          {product.productType}
                        </span>
                      </span>

                      <span
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          gap: "4px",
                        }}
                      >
                        <strong style={{ color: "#495057" }}>Part No:</strong>
                        <span>{product.partNo}</span>
                      </span>

                      <span
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          gap: "4px",
                        }}
                      >
                        <strong style={{ color: "#495057" }}>Year:</strong>
                        <span>{product.year}</span>
                      </span>
                    </div>
                  </div>

                  {/* Arrow Icon */}
                  <div
                    style={{
                      color: "#007bff",
                      fontSize: "20px",
                      opacity: 0.5,
                      transition: "all 0.3s ease",
                    }}
                  >
                    →
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                padding: "60px 20px",
                color: "#6c757d",
              }}
            >
              <img
                src="/images/no-data.avif"
                alt="No data"
                style={{
                  width: "250px",
                  maxWidth: "100%",
                  marginBottom: "20px",
                  opacity: 0.8,
                }}
              />
              <p
                style={{
                  fontSize: "16px",
                  fontWeight: "500",
                  margin: 0,
                }}
              >
                No products found
              </p>
              <p
                style={{
                  fontSize: "14px",
                  margin: "8px 0 0 0",
                  opacity: 0.7,
                  textAlign: "center",
                  maxWidth: "300px",
                }}
              >
                Don't worry if the product is unavailable. You can mention it in
                your quotation request, and we will try to source it for you.
              </p>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="primary"
            onClick={() => setShowModal(false)}
            style={{ backgroundColor: "#1A54A5" }}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Excel Upload Modal */}
      <Modal show={excelModalOpen} onHide={() => setExcelModalOpen(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Upload Excel Quotation</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div style={{ width: "100%", position: "relative" }}>
            <div
              style={{ width: "90%", marginRight: "20px", marginLeft: "20px" }}
            >
              <input
                type="file"
                accept=".xlsx,.xls"
                id="fileUpload"
                onChange={(e) => setSelectedFile(e.target.files[0])}
                style={{ display: "none" }}
              />
              <label
                htmlFor="fileUpload"
                style={{
                  display: "block",
                  width: "100%",
                  padding: "10px",
                  textAlign: "center",
                  border: "1px solid #ccc",
                  color: "#fff",
                  borderRadius: "6px",
                  cursor: "pointer",
                  backgroundColor: "#1b52a3",
                }}
              >
                📁 Choose Excel File
              </label>
            </div>

            <div
              style={{
                textAlign: "right",
                marginTop: "5px",
                marginRight: "25px",
              }}
            >
              <a
                href={referenceExcelLink}
                download={`Reference-${productType || "Excel"}.xlsx`}
                style={{
                  fontSize: "14px",
                  color: "#1b52a3",
                  textDecoration: "none",
                  cursor: "pointer",
                }}
              >
                Download reference Excel
              </a>
            </div>
          </div>

          {selectedFile && (
            <div className="mt-3">
              <p className="text-muted">Selected: {selectedFile.name}</p>
              <a
                href={URL.createObjectURL(selectedFile)}
                download={selectedFile.name}
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-link p-0"
              >
                Click here to view or download the selected file
              </a>
            </div>
          )}

          {uploadError && (
            <div className="alert alert-danger mt-3">{uploadError}</div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setExcelModalOpen(false)}
            style={{ backgroundColor: "#DA354E" }}
          >
            Close
          </Button>
          <Button
            variant="primary"
            onClick={handleExcelUpload}
            disabled={uploadLoading || !selectedFile}
            style={{ backgroundColor: "#1A54A5" }}
          >
            {uploadLoading ? "Uploading..." : "Upload"}
          </Button>
        </Modal.Footer>
      </Modal>

      <ToastContainer position="top-right" autoClose={3000} />
    </>
  );
};

export default TopSearchBar;
